import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { get, post } from "../../Common/api";
import AdminGrid, { direction } from "../AdminGrid/AdminGrid";
import { useDispatch } from "react-redux";
import { columnTypes } from "../AdminGrid/AdminGrid";
import { orderBy } from "@progress/kendo-data-query";
import Alert, {
  getNotificationForError,
  success as successNotificationType
} from "../Alert";
import { setCurrentPageNotification } from "../../redux/notificationSlice";
import getActions from "../../Common/actions";
import { useHistory } from "react-router-dom";

export default function ArchivedPosUserList() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [posUserList, setPosUserList] = useState([]);
  const [availableActions, setAvailableActions] = useState([]);
  
  const [sort, setSort] = useState([{ field: "name", dir: direction.ASC }]);
  const [filter, setFilter] = useState();
  const filterOperators = {
    text: [
      {
        text: "grid.filterStartsWithOperator",
        operator: "startswith",
      },
    ],
  };
  const actions = getActions();
  const canDelete =
    availableActions.filter((a) => a.name === actions.delete.name).length > 0;
  const unarchiveUser = async (user) => {
    // Back up list
    const originalList = [...posUserList];
    try {
      // remove user from list
      setPosUserList(posUserList.filter(u => u.id !== user.id));
      // restore user
      await post(`/posusers/${user.id}/restore`);
      // Display success message after response from server
      dispatch(
        setCurrentPageNotification({
          type: successNotificationType,
          message: `POS user restored`,
        })
      );
    } catch (error) {
      // If there was an error, restore the original list
      setPosUserList(originalList);
      // Display error message
      dispatch(setCurrentPageNotification(getNotificationForError(error)));
    }
  };

  const getActionsForPOSUser = (user) => {
    const myActions = [];
    const deleteAction = {
      title: "Unarchive",
      label: `Unarchive POS User ${user.title}`,
      onClick: (props) => unarchiveUser(props.dataItem),
    };
    if (canDelete) {
      myActions.push(deleteAction);
    }
    return myActions;
  };
  useEffect(() => {
    async function fetchData() {
      window.scrollTo(0, 0);
      try {
        const result = await Promise.all([
          get("/posusers?archived=true"),
          get("/posusers/actions"),
        ]);

        const users = result[0];
        const actions = result[1];
        if (users) {
          setPosUserList(result[0]);
        }
        if (actions) {
          setAvailableActions(actions);
        }
      } catch (error) {
        dispatch(setCurrentPageNotification(getNotificationForError(error)));
      }
    }
    fetchData();
  }, [dispatch]);

  const sortChange = (event) => {
    let sort = event.sort;
    let lastIndex = sort.length - 1;
    let currentField = sort[lastIndex].field;

    // Do not sort by actions field
    if (currentField === 'actions') {
      return;
    }

    //If the column clicked is other than name, then we have to order by name asc after the first sorted column
    if (currentField !== "name"){
      sort.push({ field: "name", dir: direction.ASC });
    }

    setSort(sort);
  }

  const listData = orderBy(
    posUserList.map((user) => ({
      ...user,
      actions: getActionsForPOSUser(user),
    })),
    sort
  );
  const columns = [
    {
      field: "name",
      title: "Name",
      isFilterable: true,
    },
    {
      field: "username",
      title: "Username",
      isFilterable: true,
    },
    {
      field: "posRoleName",
      title: "POS Role",
      isFilterable: true,
    },
    {
      field: "actions",
      title: "Actions",
      type: columnTypes.actions,
    },
  ];
  return (
    <React.Fragment>
      <Alert />

      <div className="row">
        <div className="col-md-12">
          <h2>POS Users</h2>
          <ul className="page-breadcrumb breadcrumb">
            <li>
              <i className="fa fa-user fa-fw"></i>
              <Link to="/posusers">Security</Link>
              <i className="fa fa-angle-right"></i>
            </li>
            <li>
              <Link to="/posusers">POS Users</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row MarginBottomDiv">
        <div className="col-md-12 ">
          <div className="btn-group pull-left">
            <Link to="/posusers" className="ActionLink">
              <div id="sub-div">
                <button
                  id="AddNewButton"
                  className="btn green"
                  style={{ width: "200px", marginBottom: "20px" }}
                >
                  Exit Archive View
                </button>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div data-testid="thegridcontainer">
        <AdminGrid
          columns={columns}
          data={listData}
          sortable={{ allowUnsort: false }}
          sort={sort}
          sortChange={sortChange}
          filter={filter}
          filterChange={setFilter}
          isFilterable={true}
          filterOperators={filterOperators}
        />
      </div>
    </React.Fragment>
  );
}
